<template>
    <app-slide>
    <article class="layout" id="start">
        <div class="container">
          <div class="row">
              <div class="col-xs-12 text-content">
                  <h2 class="margin-bottom-2">{{event.title}}</h2>
                  <dl v-if="event.category">
                    <dt>{{getTranslation('activity')}}</dt>
                    <dd><span class="cat"  v-for="cat in event.category" :key="cat.id">{{cat.title}}</span></dd>
                  </dl>
                  <dl v-if="event.day">
                    <dt>{{getTranslation('date')}}</dt>
                    <dd>{{event.day}}, {{event.time}}</dd>
                  </dl>
                  <dl v-if="event.venue">
                    <dt>{{getTranslation('location')}}</dt>
                    <dd>{{event.venue}}</dd>
                  </dl>
                  <img :src="event.image" alt="" class="img-responsive margin-top-2 margin-bottom-2" v-if="event.image"> 
                  <div v-html="event.body"></div>
              </div>
              <div class="col-xs-12 text-content">
                 <h2 class="margin-top-4 margin-bottom-2">{{getTranslation('upcoming-events')}}</h2>
                  <ul class="list-style-programme">
                    <router-link tag="li" :to="'/programme/' + item.slug" v-for="item in items" :key="item.id">
                      <p class="roman">{{item.day}} {{item.time}}</p>
                      <p>{{item.title}}</p>
                    </router-link>
                  </ul>
              </div>
          </div>
        </div>
    </article>
    </app-slide>
</template>


<script>
  import {store} from '../store/store'
  import appSlide from '../transitions/AppSlide'
  import mixinLanguages from '../mixins/Language'
  export default {
    name: 'programmeDetail',
    components: {
      appSlide
    },
    props: ['slug'],
    mixins: [mixinLanguages],
    data() {
      return {
        event:'',
        items:[],
      }
    },
    mounted () {
      this.getEvent();
      this.getEvents();
      store.dispatch('setDestUrl', '__/__');
      store.dispatch('setDestChange', false);
    },
    computed:{
      lang() { 
        return this.$store.state.langUrl;
      },
    },
    watch: {
      // use the watch to react on the value change.
      lang(newValue) {
        this.getEvent();
        this.getEvents();
      },
    },
    methods: {
      getEvent () {
        let baseUrl = this.$store.getters.getBaseUrl;
        let lang = this.$store.getters.getLangState;
        let url = baseUrl + lang + '/api/v1/programme/' + this.slug + '.json';
        this.$http.get(url).then((response) => {
          this.event = response.data.data[0];
        })
      },
      getEvents: function() {
        let baseUrl = this.$store.getters.getBaseUrl;
        let lang = this.$store.getters.getLangState;
        let url = baseUrl + lang + '/api/v1/programme-current.json';
        this.$http.get(url).then((response) => {
          this.items = response.data.data;
        })
      },
      addFavourite(obj) {
        store.commit('addFavEvents', obj);
      },
    }
  }
</script>

<style lang="scss">
  
</style>



// WEBPACK FOOTER //
// src/views/ProgrammeDetail.vue